(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    /* ORIGINAL ONSCROLL - MAKES HEADER APPEAR AFTER SCROLLED PAST HEADER'S BOTTOM-Y VALUE! */

    /* 
    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    } */

    onScroll() {
  const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

  if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

  // ✅ NEW: background + sticky behavior triggers after 5px instead of headerBounds.bottom
  const SCROLL_THRESHOLD = 5;

  const pastThreshold = scrollTop > SCROLL_THRESHOLD;

  if (scrollTop > this.currentScrollTop && pastThreshold) {
    this.header.classList.add('scrolled-past-header');
    if (this.preventHide) return;
    requestAnimationFrame(this.hide.bind(this));
  } else if (scrollTop < this.currentScrollTop && pastThreshold) {
    this.header.classList.add('scrolled-past-header');
    if (!this.preventReveal) {
      requestAnimationFrame(this.reveal.bind(this));
    } else {
      window.clearTimeout(this.isScrolling);

      this.isScrolling = setTimeout(() => {
        this.preventReveal = false;
      }, 66);

      requestAnimationFrame(this.hide.bind(this));
    }
  } else if (!pastThreshold) {
    // ✅ NEW: if you're within the first 0–5px, treat as "top"
    this.header.classList.remove('scrolled-past-header');
    requestAnimationFrame(this.reset.bind(this));
  }

  this.currentScrollTop = scrollTop;
}


    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nutrition-table-2"] && !Shopify.designMode) return;
  try {
    
  const sectionContainer = document.querySelector('.nutrition-table-section');
  const toggleButtons = sectionContainer.querySelectorAll('.toggle-button');
  // const table = sectionContainer.querySelector('.nutrition-table');
  const table = sectionContainer.querySelector('table.nutrition-table');
  

  toggleButtons.forEach((button) => {
    button.addEventListener('click', () => {
      toggleButtons.forEach((btn) => btn.classList.remove('active'));
      button.classList.add('active');

      const target = button.getAttribute('data-target');
      sectionContainer.setAttribute('data-mode', target);

      if (target === 'nutrition') {
        // table.classList.add('nutrition-view');
        table.style.display = "none";
        // table.classList.remove('allergen-view');
      } else {
         table.style.display = "block";
        // table.classList.add('allergen-view');
        // table.classList.remove('nutrition-view');
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nutrition-table"] && !Shopify.designMode) return;
  try {
    
  const toggleButtons = document.querySelectorAll('.toggle-button');
  const table = document.getElementById('nutrition-table');

  toggleButtons.forEach((button) => {
    button.addEventListener('click', () => {
      toggleButtons.forEach((btn) => btn.classList.remove('active'));
      button.classList.add('active');

      if (button.dataset.mode === 'nutrition') {
        table.classList.remove('allergen-view');
        table.classList.add('nutrition-view');
      } else {
        table.classList.remove('nutrition-view');
        table.classList.add('allergen-view');
      }
    });
  });

  } catch(e) { console.error(e); }
})();
})();
